import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink, Route, Switch } from 'react-router-dom'

import UserDropdown from './UserDropdown'
import Bookings from './Bookings'
import { UserNavLayout, DropdownMenu } from './DesignFunctions'
import BookingDetails from './BookingDetails'
import Account from './Account'
import UserAffiliate from './UserAffiliate'

class UserPages extends Component {
	state = {
		showAffiliatesDropdown: false,
	}
	componentWillReceiveProps = newProps => {
		if(this.props.match.params.id !== newProps.match.params.id){
			this.setState({ showAffiliatesDropdown: false })
		}
	}
	toggleAffiliatesDropdown = () => {
		this.setState(state => ({ showAffiliatesDropdown: !state.showAffiliatesDropdown }))
	}
	render() {
		let { t } = this.context
		return(
			<div className="UserPages">
				<div className="container">
					<UserNavLayout customClass="user-pages-nav">
						<div className="links">
							<NavLink exact to="/bookings" className="link" activeClassName="active">{t('bookings')}</NavLink>
							{this.renderAffiliateLink()}
							<NavLink to="/account" className="link" activeClassName="active">{t('my_account')}</NavLink>
						</div>
						<div className="pusher"/>
						<UserDropdown/>
					</UserNavLayout>
					<Switch>
						<Route path="/app" component={Bookings}/>
						<Route exact path="/bookings" component={Bookings} />
						<Route path="/bookings/:id" component={BookingDetails}/>
						<Route path="/affiliate/:id" component={UserAffiliate}/>
						<Route path="/account" component={Account}/>
					</Switch>
				</div>
			</div>
		)
	}

	renderAffiliateLink = () => {
		let { t } = this.context
		let { affiliates } = this.props
		let { showAffiliatesDropdown } = this.state

		if (affiliates.length === 1) {
			return (
				<NavLink to={"/affiliate/" + affiliates[0].id} activeClassName="active">{affiliates[0].name}</NavLink>
			)
		}
		else if (affiliates.length === 0) {
			return null
		}
		else {
			return(
			<DropdownMenu title={t('my_affiliates')} toggleDropdown={this.toggleAffiliatesDropdown} active={showAffiliatesDropdown}>
				{affiliates.map(aff =>
					<NavLink key={aff.id} to={"/affiliate/" + aff.id} activeClassName="active">{aff.name}</NavLink>
				)}
			</DropdownMenu>
		)
		}
	}
}

UserPages.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	affiliates: state.dataReducer.userAffiliates,
})
export default connect(mapStateToProps)(UserPages);



// WEBPACK FOOTER //
// ./src/components/UserPages.js